import React from 'react';
import {useStyles} from './TakisSimpleText.styles';
import PropTypes from 'prop-types';

function TakisSimpleText({paragraph, variation="simple", mod}) {
  const classes = useStyles();

  TakisSimpleText.propTypes = {
    paragraph: PropTypes.string.isRequired,
    variation: PropTypes.string,
    mod: PropTypes.string,
  };

  return (
    <div
      className={`${mod} ${classes.text} ${classes[variation]}`}
      dangerouslySetInnerHTML={{__html: paragraph}}
    />
  );
}

export default TakisSimpleText;
